import { useEffect } from 'react';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { supabase } from '@/integrations/supabase/client';

// Key used to pass pending navigation from push tap to the router
export const PUSH_NAV_KEY = 'push_pending_nav';

// Store the current device token so we can remove it on sign-out
let currentToken: string | null = null;

export async function removeCurrentDeviceToken(userId: string) {
  if (!currentToken) return;
  try {
    await supabase
      .from('device_tokens')
      .delete()
      .eq('user_id', userId)
      .eq('token', currentToken);
    console.log('🔔 Token eliminado de Supabase');
  } catch (err) {
    console.error('🔔 Error eliminando token:', err);
  }
}

// Register tap listener at module level so it captures cold-start taps
// before React or Auth are ready.
if (Capacitor.isNativePlatform()) {
  PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
    console.log('🔔 Notificación tocada:', JSON.stringify(notification));
    const data = notification.notification?.data;
    if (data?.type === 'court_assigned' && data?.action_url) {
      sessionStorage.setItem(PUSH_NAV_KEY, data.action_url);
    }
  });
}

export function usePushNotifications(userId: string | null) {
  useEffect(() => {
    if (!userId || !Capacitor.isNativePlatform()) return;

    const init = async () => {
      try {
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive === 'prompt') {
          permStatus = await PushNotifications.requestPermissions();
        }
        if (permStatus.receive !== 'granted') {
          console.log('🔔 Permiso denegado');
          return;
        }

        await PushNotifications.addListener('registration', async (token) => {
          console.log('🔑 Token recibido:', token.value);
          currentToken = token.value;

          await supabase.from('device_tokens').upsert(
            {
              user_id: userId,
              token: token.value,
              platform: Capacitor.getPlatform(),
              updated_at: new Date().toISOString(),
            },
            { onConflict: 'user_id,token' }
          );
          console.log('🔔 Token guardado en Supabase');
        });

        await PushNotifications.addListener('registrationError', (error) => {
          console.error('🔔 Error de registro:', JSON.stringify(error));
        });

        await PushNotifications.addListener('pushNotificationReceived', (notification) => {
          console.log('🔔 Notificación recibida:', JSON.stringify(notification));
        });

        await PushNotifications.register();
      } catch (err) {
        console.error('🔔 Error inicializando push:', err);
      }
    };

    init();

    return () => {
      PushNotifications.removeAllListeners();
    };
  }, [userId]);
}
